<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="90" :isOpen="isOpen" :closeCompleteAction="() => { closeCompleteAction(PROFILE_BOX_LIST.PLAY_STYLE, true, false, false) }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction(PROFILE_BOX_LIST.PLAY_STYLE, true, false, false)" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">플레이 스타일</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">회원님의 축구 포지션에 맞는<br>플레이 스타일을 한 가지 선택할 수 있습니다.</div>
                </div>
                <div style="margin-top: 40px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; line-height: 24px;">포워드</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSelectPlayStyle(each)" :class="selectPlayStyle === each ? 'active' : ''" v-for="each, i in foward" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; line-height: 24px;">미드필더</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSelectPlayStyle(each)" :class="selectPlayStyle === each ? 'active' : ''" v-for="each, i in midfielder" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; line-height: 24px;">수비/골키퍼</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSelectPlayStyle(each)" :class="selectPlayStyle === each ? 'active' : ''" v-for="each, i in defense_n_keeper" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="selectPlayStyle !== ''" class="save_btn_active">저장하기</div>
                <div v-else class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode'
import { PROFILE_BOX_LIST } from '@/Constants'

export default {
    name: 'SettingPlayStyle',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            selectPlayStyle: '',
            foward: ['타겟형 스트라이커', '폴스 나인', '포처', '컴플리트 포워드', '프레싱 포워드', '크랙', '어드밴스 포워드', '섀도우 스트라이커', '클래식 윙어', '인버티드 윙어'],
            midfielder: ['미들라이커', '플레이메이커', '메짤라', '홀딩 미드필더', '박스 투 박스', '볼란치', '앵커맨'],
            defense_n_keeper: ['하프백', '스위퍼', '스토퍼', '폴스 풀백', '인버티드 윙백', '숏 스토퍼', '스위퍼 키퍼'],
            PROFILE_BOX_LIST: PROFILE_BOX_LIST
        }
    },
    methods: {
        setSelectPlayStyle(playStyle) {
            this.selectPlayStyle = playStyle
        },
        async save() {
            this.$GlobalStore.showProgress()

            const formData = new FormData()
            formData.append('playstyle', this.selectPlayStyle)

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.selectPlayStyle = ''
                this.$GlobalStore.hideProgress()
                this.closeCompleteAction(PROFILE_BOX_LIST.PLAY_STYLE, true, false, true)
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.selectPlayStyle = ''
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}
</style>